import {jsonFetch} from "./JsonFetch";

let Contact = {
    /**
     *
     */
    getOne: async (id) => {
        let url = '/contact/' + id;

        const response = await jsonFetch('GET', url);
        if (response.ok) {
            return response.json();
        }
        throw Error(response.statusText);
    },

    /**
     *
     */
    getAll: async (payload) => {
        let url = '/contacts';

        const response = await jsonFetch('POST', url, payload);
        if (response.ok) {
            return response.json();
        }
        throw Error(response.statusText);
    },

    /**
     *
     */
    create: async (payload) => {
        let url = '/contact';

        const response = await jsonFetch('POST', url, payload);
        if (response.ok) {
            return response.json();
        }
        throw Error(response.statusText);
    },

    /**
     *
     */
    update: async (id, payload) => {
        let url = '/contact/' + id;

        const response = await jsonFetch('PUT', url, payload);
        if (response.ok) {
            return response.json();
        }
        throw Error(response.statusText);
    },

    /**
     *
     */
    delete: async (id) => {
        let url = '/contact/' + id;

        const response = await jsonFetch('DELETE', url);
        if (response.ok) {
            return null;
        }

        throw Error(response.statusText);
    },

    /**
     *
     */
    bulkDelete: async (ids) => {
        let url = '/contacts';

        const response = await jsonFetch('DELETE', url, {
            'contacts_id': ids
        });

        if (response.ok) {
            return null;
        }

        throw Error(response.statusText);
    },
}

export {Contact};